import React from 'react';
import PropTypes from 'prop-types';
import Svg from '../../Svg';
import FilterParameter from './FilterParameter';
import classNames from 'classnames';

const FilterBody = props => (
    <div
        className={classNames(
            'ui-filter ui-popover sales__filterRightAlign',
            { hidden: !props.opened }
        )}
    >
        <div
            className="ui-filter__pointer ui-popoverPointer"
        />
        <div className="ui-filter__header ui-popoverHeader">
            <span className="ui-filter__title">{props.title}</span>
            <button
                className="ui-btn ui-btn_secondary ui-filter__header__button"
                onClick={props.onCancelClick}
            >
                <Svg size="Medium" iconName="cross" />
            </button>
        </div>
        <div className="ui-filter__gradient ui-filter__gradient_top" />
        <div className="ui-filter__body ui-accordion">
            {props.parameters.map(parameter =>
                <FilterParameter
                    {...parameter}
                    key={parameter.name}
                    selected={props.selection[parameter.name]}
                    isExpanded={props.expanded.indexOf(parameter.name) !== -1}
                    hidden={props.hiddenParams.indexOf(parameter.name) !== -1}
                    onOptionSelect={props.onOptionSelect}
                    onParameterExpand={props.onParameterExpand}
                />
            )}
        </div>
        <div className="ui-filter__gradient" />
        <div className="ui-filter__footer">
            <button
                className="ui-filter__button ui-btn ui-btn_secondary"
                onClick={props.onCancelClick}
            >
                Cancel
            </button>
            <button
                className="ui-filter__button ui-btn ui-btn_primary"
                onClick={() => props.onApplyClick()}
            >
                Apply
            </button>
        </div>
    </div>
);

FilterBody.propTypes = {
    opened: PropTypes.bool,
    title: PropTypes.string,
    parameters: PropTypes.arrayOf(PropTypes.object).isRequired,
    onOptionSelect: PropTypes.func.isRequired,
    onParameterExpand: PropTypes.func.isRequired,
    onCancelClick: PropTypes.func.isRequired,
    onApplyClick: PropTypes.func.isRequired,
    expanded: PropTypes.array,
    selection: PropTypes.object,
    hiddenOptions: PropTypes.object,
    hiddenParams: PropTypes.array
};

export default FilterBody;



// WEBPACK FOOTER //
// ./src/js/modules/Filter/components/FilterBody.js